export default __webpack_public_path__ + "static/media/Synagoga_sm.a773a645.jpg";